import Comm from '../services/comm';

function mapError(phpErrors){
    let errors = [];
    phpErrors.forEach(error => {
        let frontError = null;
        switch(error){
            case 'Recorder not set':
                frontError = "Kérem válassza ki ki vette fel a munkát!";
                break;
            case 'Record time not set':
                frontError = "Kérem adja meg a munka felvételének idejét!";
                break;
            case 'Record status not set':
                frontError = "Kérem adja meg a felvétel státuszát!";
                break;
            case 'Client not set':
                frontError = "Kérem válasszon megrendelőt!";
                break;
            case 'Device type not set':
                frontError = "Kérem adja meg a készülék típusát!";
                break;
            case 'Colors number not set':
                frontError = "Kérem adjon meg Colors sorozatszámot!";
                break;
            case 'Event not set':
                frontError = "Kérek töltse ki a felvétel sort!";
                break;
            case 'WorksheetId not set':
                return ["Belső hiba történt!"];
                break;
            case 'Time not set':
                frontError = "Kérek töltse az dátumot!";
                break;
            case 'UserId not set':
                frontError = "Kérek válasszon felhasználót!";
                break;
            case 'InnerEvent not set':
                frontError = "Kérek adjon meg eseményt!";
                break;
            case 'Serialnumber not set':
                frontError = "Kérek adjon meg sorozatszámot!";
                break;
            case 'Prize not set':
                frontError = "Kérek adja meg az összeget!";
                break;
            case 'Status not set':
                frontError = "Kérek adjon meg státuszt!";
                break;
            default:
                frontError = error;
                break;
        }

        errors.push(frontError);
    });

    return errors;
}

export default{
    namespaced: true,
    state: {
        loading: false,
        error: null,
        saveError: null,
        getLoading: false,
        getError: null,
        saveEventError: null,
        saveEventLoading: false
    },
    actions: {
        getWorksheetList(context, data){
            context.state.error = null;
            context.state.loading = true;
            let params = {
                filter: data.filter,
                order: data.order,
                showDone: data.showDone
            };
            Comm.postData('worksheets.php', params).then(
                res => {
                    data.result(res);
                    context.state.loading = false;
                },
                rej => {
                    data.reject(rej);
                    context.state.loading = false;
                }
            )
        },
        getWorksheet(context, data){
            context.state.getError = null;
            context.state.getLoading = true;
            Comm.getData(`worksheet.php?id=${data.id}`).then(
                res => {
                    if(res.data.status == 'ok'){
                        data.result(res);
                    } else {
                        context.getError = 'Hiba történt betöltés közben, kérem forduljon a rendszergazdához!';
                        data.reject(res);
                    }
                    context.state.getLoading = false;
                },
                rej => {
                    context.error = 'Hiba történt betöltés közben, kérem forduljon a rendszergazdához!';
                    data.reject(rej);
                    context.state.getLoading = false;
                }
            );
        },
        saveWorksheet(context, data){
            context.state.saveError = null;
            context.state.loading = true;
            Comm.postData('worksheet.php', {data: data.data}).then(
                res => {
                    if(res.data.status === 'ok'){
                        data.result(res);
                    } else {
                        context.state.saveError = mapError(res.data.errors);
                        data.reject(res);
                    }
                    context.state.loading = false;
                },
                rej => {
                    context.state.saveError = ['Hiba történt mentés közben, kérem forduljon a rendszergazdához!'];
                    data.reject(rej);
                    context.state.loading = false;
                }
            )
        },
        editWorksheet(context, data){
            context.state.saveError = null;
            context.state.loading = true;
            Comm.putData('worksheet.php', {data: data.data}).then(
                res => {
                    if(res.data.status === 'ok'){
                        data.result(res);
                    } else {
                        context.state.saveError = mapError(res.data.errors);
                        data.reject(res);
                    }
                    context.state.loading = false;
                },
                rej => {
                    context.state.saveError = ['Hiba történt mentés közben, kérem forduljon a rendszergazdához!'];
                    data.reject(rej);
                    context.state.loading = false;
                }
            )
        },
        saveWorksheetEvent(context, data){
            context.state.saveEventError = null;
            context.state.saveEventLoading = true;
            Comm.postData('worksheetevent.php', {data: data.data}).then(
                res => {
                    if(res.data.status === 'ok'){
                        data.result(res);
                    } else {
                        context.state.saveEventError = mapError(res.data.errors);
                        data.reject(res);
                    }
                    context.state.saveEventLoading = false;
                },
                rej => {
                    context.state.saveEventError = ['Hiba történt mentés közben, kérem forduljon a rendszergazdához!'];
                    data.reject(rej);
                    context.state.saveEventLoading = false;
                }
            )
        },
    }
}



// WEBPACK FOOTER //
// ./src/store/worksheetStore.js